import React, { createContext, useContext, useState, useCallback } from "react";
import { DICT } from "@/lib/i18n";

const I18nContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("go_lang") || "en");

  const setLanguage = useCallback((l) => {
    setLang(l);
    localStorage.setItem("go_lang", l);
    document.documentElement.lang = l;
  }, []);

  const toggle = useCallback(() => setLanguage(lang === "en" ? "fr" : "en"), [lang, setLanguage]);

  const t = useCallback(
    (key) => (DICT[lang] && DICT[lang][key]) || DICT.en[key] || key,
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLanguage, toggle, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
